module.exports = __webpack_public_path__ + "img/EsclusaComando.72a47a1e.svg";